import { h, Component } from "preact";
import BetaSwitch from "./BetaSwitch";
import { redirectAfterToggle } from "./utils";

class DropdownMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: "",
      value: {},
      beta: this.props.betaToggle
    };

    this.onSearchChange = this.onSearchChange.bind(this);
    this.onInputValueChange = this.onInputValueChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.emptyInputText = this.emptyInputText.bind(this);
    this.toggleBeta = this.toggleBeta.bind(this);
  }

  onSearchChange(e) {
    this.setState({
      search: e.target.value
    });
  }

  onInputValueChange(e) {
    this.setState({
      value: {
        value: e.target.value,
        label: e.target.value
      }
    });
  }

  emptyInputText() {
    this.setState({
      value: {
        value: "",
        label: ""
      }
    });
  }

  onClick(e, value) {
    e.stopPropagation();
    e.preventDefault();

    this.props.onChange(value);
  }

  toggleBeta(userId) {
    const beta = !this.state.beta;
    this.setState(
      {
        beta
      },
      () => {
        this.props.client
          .updateUserProfile(userId, { new_ui: beta })
          .then(() => {
            if (beta) {
              const path = window.location.pathname;
              redirectAfterToggle(path);
            }
          });
      }
    );
  }

  getUserProfile(userId) {
    this.setState({ profile: { loading: true } });
    this.props.client.getUserProfile(userId).then(profile => {
      this.setState({ beta: profile.new_ui, profile });
    });
  }

  render(
    {
      values = [],
      typeaHead = false,
      onChange,
      open,
      style,
      itemStyle,
      menuName,
      betaToggle,
      userId,
      client
    },
    { search, profile }
  ) {
    let filteredValues = [...values];

    if (userId && client && !profile && betaToggle) {
      this.getUserProfile(userId);
    }

    if (typeaHead) {
      filteredValues = filteredValues.filter(v => v.label === search);
    }

    return (
      <nav
        class={`user-widget__dropdown__menu ${open &&
          "user-widget__dropdown__menu--open"} ${menuName}`}
        style={style}
      >
        {filteredValues && !!filteredValues.length && typeaHead && (
          <input type="text" onChange={this.onSearchChange} value={search} />
        )}
        <ul>
          {filteredValues.map(value => (
            <li>
              <a
                class="user-widget__dropdown__menu__list_item"
                style={itemStyle}
                href={value.value}
                role="menuitem"
                aria-label="account links"
                rel="noopener noreferrer"
              >
                {value.label}
              </a>
            </li>
          ))}
        </ul>
        {betaToggle && userId && (
          <BetaSwitch
            beta={this.state.beta}
            toggleBeta={() => this.toggleBeta(userId)}
          />
        )}
        {(!filteredValues || !filteredValues.length) && (
          <div class="user-widget__dropdown__menu__input">
            <input
              value={this.state.value.value}
              onInput={this.onInputValueChange}
              type="text"
              onClick={e => e.stopPropagation()}
            />
            <button
              class="widget__dropdown__menu__input__button"
              onClick={e => {
                e.stopPropagation();
                onChange(this.state.value);
                this.emptyInputText();
              }}
            >
              Ok
            </button>
          </div>
        )}
      </nav>
    );
  }
}

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/DropdownMenu.js